import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import actions from './actions'

const initialState = {
  isAuthInitialized: false,
  isAuthenticated: null,
  isSigningOut: false,
  username: '',
  authCodeUserAlias: null,
  referrerUserAlias: '',
}

const reducer = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case actions.initializeAuth.INIT_TYPE:
    case actions.initializeAuth.FAILURE_TYPE: {
      return {
        ...state,
        isAuthInitialized: false,
      }
    }
    case actions.initializeAuth.SUCCESS_TYPE: {
      return {
        ...state,
        isAuthInitialized: true,
      }
    }
    case actions.updateField.SUCCESS_TYPE: {
      return {
        ...state,
        [payload.key]: payload.value,
      }
    }
    case actions.setAuthUsername.SUCCESS_TYPE: {
      return {
        ...state,
        username: payload.username,
      }
    }
    case actions.resetLogIn.SUCCESS_TYPE: {
      return {
        ...state,
        username: '',
      }
    }
    case actions.logInUser.SUCCESS_TYPE: {
      return {
        ...state,
        username: payload.username,
        authCodeUserAlias: payload.userAlias,
      }
    }
    case actions.confirmLogInUser.SUCCESS_TYPE: {
      return {
        ...state,
        isAuthenticated: true,
      }
    }
    case actions.signOutUser.SUCCESS_TYPE: {
      return {
        ...state,
        isAuthenticated: false,
      }
    }
    case actions.checkIsAuthenticated.SUCCESS_TYPE: {
      return {
        ...state,
        isAuthenticated: payload.isAuthenticated,
      }
    }
    case 'RESET': {
      return {
        ...initialState,
        isSigningOut: true,
      }
    }
    default:
      return state
  }
}

const persistConfig = {
  key: 'authentication',
  storage,
  whitelist: ['username'],
}

export default persistReducer(persistConfig, reducer)
